// extracted by mini-css-extract-plugin
module.exports = {"green":"subHeader-module--green--1qarF"};